import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { bodyNoScroll, getViewportWidth } from 'helpers/utilities';
import Cross from 'src/assets/icons/close.svg';
import Compress from 'src/assets/icons/compress.svg';
import { appendModalToDom } from 'helpers/modal';
import theme from 'src/lib/theme';
import FocusTrap from 'focus-trap-react';
import { Overlay, Wrap, Dialog, CloseIcon } from './Modal.styled';

const configuratorModalEl = appendModalToDom('configurator-modal', { zIndex: 10001 });

const Modal = ({ onClose, children, crossTheme = { base: 'light' }, isFullScreen, disableFullScreen, isMessage }) => {
  const [blurred, setBlurred] = useState(false);
  const [focusTrapActive, setFocusTrapActive] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    if (
      isMessage ||
      getViewportWidth() >= (disableFullScreen ? theme.breakpoints.tablet : theme.breakpoints.tabletLarge)
    ) {
      setTimeout(() => setBlurred(true), 100);
    }

    configuratorModalEl.style.display = 'block';

    if (!isMessage) {
      bodyNoScroll.add();
    }

    return () => {
      if (!isMessage) {
        bodyNoScroll.remove();
      }

      configuratorModalEl.style.display = 'none';
    };
  }, [disableFullScreen]);

  useEffect(() => {
    const modalEl = modalRef.current;

    if (modalEl) {
      modalEl.style.minHeight = `${2 * Math.round(modalEl.firstElementChild.offsetHeight / 2)}px`;
    }

    setFocusTrapActive(!!children);
  }, [children]);

  return createPortal(
    <>
      <Overlay open={blurred} onClick={onClose} disableFullScreen={disableFullScreen} isMessage={isMessage} />
      <FocusTrap active={focusTrapActive} focusTrapOptions={{ allowOutsideClick: true }}>
        <Wrap isFullScreen={isFullScreen} disableFullScreen={disableFullScreen} isMessage={isMessage}>
          <Dialog isFullScreen={isFullScreen} disableFullScreen={disableFullScreen} ref={modalRef}>
            {children}
            <CloseIcon onClick={onClose} crossTheme={crossTheme} isMessage={isMessage}>
              {isFullScreen ? <Compress /> : <Cross />}
            </CloseIcon>
          </Dialog>
        </Wrap>
      </FocusTrap>
    </>,
    configuratorModalEl
  );
};

export default Modal;
